import { render, staticRenderFns } from "./updateMetaData.vue?vue&type=template&id=de1dd042"
import script from "./updateMetaData.vue?vue&type=script&lang=js"
export * from "./updateMetaData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports